import { SYS_BORDER_RADIUS_MD, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_25 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { StyledExtendedSelection, StyledImageLG } from '../extended-selection/index.styles.js';
import { FormMessage } from '../form-message/index.js';
export const StyledFormMessage = styled(FormMessage) `
  padding: ${SYS_SPACE_FIXED_200};
`;
export const StyledInner = styled.div `
  flex-direction: column;
  display: flex;

  :has(${StyledExtendedSelection}) {
    :has(input[type='radio']) {
      gap: ${SYS_SPACE_FIXED_25};
    }

    :has(input[type='radio']):has(${StyledImageLG}) {
      gap: ${SYS_SPACE_FIXED_200};
    }

    :has(input[type='checkbox']) {
      gap: ${SYS_SPACE_FIXED_200};
    }
  }
`;
export const StyledExtendedSelectionGroup = styled.fieldset `
  padding: 0;
  margin: 0;
  border: none;

  ${StyledExtendedSelection} {
    :has(input[type='radio']) {
      &:not(:first-child):not(:last-child) {
        border-radius: 0;
      }

      &:first-child {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:last-child {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    :has(input[type='radio']):has(${StyledImageLG}) {
      &:not(:first-child):not(:last-child) {
        border-radius: ${SYS_BORDER_RADIUS_MD};
      }

      &:first-child {
        border-radius: ${SYS_BORDER_RADIUS_MD};
      }

      &:last-child {
        border-radius: ${SYS_BORDER_RADIUS_MD};
      }
    }
  }
`;
//# sourceMappingURL=index.styles.js.map